import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";

const Section = ({ title, children }) => (
  <div className="border-b border-border py-10">
    <h2 className="font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
      {title}
    </h2>
    <div className="mt-4 max-w-3xl space-y-4 text-sm leading-relaxed text-muted-foreground">
      {children}
    </div>
  </div>
);

export function ShippingReturns() {
  return (
    <div>
      <PageHeader eyebrow="The fine print, kept short" title="Shipping & Returns" />
      <div className="px-5 py-4 sm:px-10 lg:px-16">
        <Reveal>
          <Section title="Shipping">
            <p>Orders are processed within 2 business days. You'll get a carrier tracking link by email the moment your order leaves the studio.</p>
            <p>Standard domestic shipping typically takes 3–7 business days. Every order over $150 ships free. International shipping is available at checkout, with duties and taxes calculated up front where supported.</p>
          </Section>
          <Section title="Returns">
            <p>30 days from delivery. Gear must be unworn, unwashed, with tags attached. Reply to your order confirmation email or use the contact page to start a return — we'll send a label and instructions.</p>
            <p>Refunds land on the original payment method within 5–10 business days of the return arriving. Limited-run and final-sale items are marked on the product page and can't be returned.</p>
          </Section>
          <Section title="Exchanges">
            <p>Need a different size? The fastest route is to return the original and place a new order — limited runs move fast and we can't hold stock against an exchange.</p>
          </Section>
        </Reveal>
      </div>
    </div>
  );
}

export function Privacy() {
  return (
    <div>
      <PageHeader eyebrow="Legal" title="Privacy Policy" />
      <div className="px-5 py-4 sm:px-10 lg:px-16">
        <Reveal>
          <Section title="What we collect">
            <p>When you shop, sign up, or contact us we collect the details needed to run the store: name, email, shipping address, order history, and — if you opt in — your phone number for SMS drop alerts. Payment details are processed securely by Shopify and never touch our servers.</p>
          </Section>
          <Section title="How we use it">
            <p>To fulfil orders, send tracking, run the drop list you asked to join, and improve the store. We don't sell your data. Ever.</p>
          </Section>
          <Section title="Your controls">
            <p>Unsubscribe from email or SMS any time with one tap. To access, correct, or delete your data, email support@trailnone.com and we'll handle it.</p>
          </Section>
          <Section title="Cookies & analytics">
            <p>We use essential cookies to keep your cart working and lightweight analytics to understand what the crew actually wears. No dark patterns.</p>
          </Section>
        </Reveal>
      </div>
    </div>
  );
}

export function Terms() {
  return (
    <div>
      <PageHeader eyebrow="Legal" title="Terms of Service" />
      <div className="px-5 py-4 sm:px-10 lg:px-16">
        <Reveal>
          <Section title="The store">
            <p>TRAILNONE operates this storefront. Product availability, pricing and descriptions are managed in real time — if something sells out mid-checkout, the cart will tell you before you pay.</p>
          </Section>
          <Section title="Orders">
            <p>An order is accepted when payment is confirmed. We reserve the right to cancel and refund orders placed in error or in cases of suspected fraud or reseller botting on limited runs.</p>
          </Section>
          <Section title="Intellectual property">
            <p>All designs, graphics, photography and the TRAILNONE name and marks are the property of TRAILNONE. Don't bootleg the crew.</p>
          </Section>
          <Section title="Liability">
            <p>Gear is made to be lived in, but use common sense. To the maximum extent permitted by law, TRAILNONE's liability is limited to the purchase price of the item concerned.</p>
          </Section>
        </Reveal>
      </div>
    </div>
  );
}
